import React from 'react';
import './eventCard.scss';
import {ReactComponent as DATE_ICON} from "../../assets/icons/date_icon_2.svg";
import {useNavigate} from "react-router-dom";
import {removeHtml} from "../../util/removeHtmlFromString";

interface Props {
    id: number,
    date: string,
    image: string,
    title: string,
    description: string,
}

export const EventCard: React.FC<Props> = ({id, date, image, title, description}) => {

    const navigate = useNavigate();
    return (
        <div className={'app-event'} key={id + title} onClick={() => navigate(`/app/news/events/${id}`)}>
            <div className={'app-event_img'}>
                <img src={image} alt=""/>
            </div>

            <div className={'app-event_content'}>
                <h2>{title}</h2>
                <p>{removeHtml(description)}</p>
                <div className={'date'}>
                    <DATE_ICON/> <span>{date}</span>
                </div>
            </div>
        </div>
    );
};

